import { createAtlasButtonVariant as createButtonVariant, getButtonTokens, } from "../utils/createAtlasButtonVariant.js";
const getIconOffsets = (size, tokens) => (Object.assign(Object.assign(Object.assign({}, (size === "large" && {
    marginLeft: "0",
    marginRight: "0",
})), (size === "medium" && {
    marginLeft: `-${tokens.semantic.spacing.default.value}`,
    marginRight: `-${tokens.semantic.spacing.default.value}`,
})), (size === "small" && {
    marginLeft: `-${tokens.semantic.spacing.md.value}`,
    marginRight: `-${tokens.semantic.spacing.md.value}`,
})));
export const button = (tokens) => {
    const { button, semantic, loadingIndicator } = getButtonTokens(tokens);
    return {
        MuiButtonBase: {
            defaultProps: {
                // The props to change the default for.
                disableRipple: true, // No more ripple, on the whole application 💣!
            },
            styleOverrides: {
                root: {},
            },
        },
        MuiButton: {
            defaultProps: {
                disableElevation: true,
            },
            styleOverrides: {
                root: ({ ownerState }) => (Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ borderRadius: button.borderRadius.value, fontWeight: button.fontWeight.value, fontSize: button.fontSize.value, height: button.height.value, padding: `0 ${button.paddingHorizontal.value}`, gap: button.gap.value, 
                    // Need this do padding-horizontal take effect
                    minWidth: "auto" }, ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.size) === "large" && {
                    fontSize: button.large.fontSize.value,
                    height: button.large.height.value,
                })), ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.size) === "small" && {
                    fontSize: button.small.fontSize.value,
                    fontWeight: button.small.fontWeight.value,
                    height: button.small.height.value,
                })), { "&:focus": {
                        boxShadow: button.focus.boxShadow.value.stringValue,
                    } }), ((!(ownerState === null || ownerState === void 0 ? void 0 : ownerState.color) || (ownerState === null || ownerState === void 0 ? void 0 : ownerState.color) === "primary") &&
                    (ownerState === null || ownerState === void 0 ? void 0 : ownerState.variant) === "contained" && Object.assign({}, createButtonVariant(button.primary, tokens)))), ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.color) === "destructive" &&
                    (ownerState === null || ownerState === void 0 ? void 0 : ownerState.variant) === "contained" && Object.assign({}, createButtonVariant(button.destructive.primary, tokens)))), ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.variant) === "outlined" && {
                    // For all secondary buttons, we adjust the horizontal padding
                    // to make the border look like it's  drawn inside
                    padding: `0 calc(${button.paddingHorizontal.value} - ${button.secondary.default.borderWidth.value})`,
                })), ((!(ownerState === null || ownerState === void 0 ? void 0 : ownerState.color) || (ownerState === null || ownerState === void 0 ? void 0 : ownerState.color) === "primary") &&
                    (ownerState === null || ownerState === void 0 ? void 0 : ownerState.variant) === "outlined" && Object.assign({}, createButtonVariant(button.secondary, tokens)))), ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.color) === "destructive" &&
                    (ownerState === null || ownerState === void 0 ? void 0 : ownerState.variant) === "outlined" && Object.assign({}, createButtonVariant(button.destructive.secondary, tokens)))), ((!(ownerState === null || ownerState === void 0 ? void 0 : ownerState.color) || (ownerState === null || ownerState === void 0 ? void 0 : ownerState.color) === "primary") &&
                    (ownerState === null || ownerState === void 0 ? void 0 : ownerState.variant) === "text" && Object.assign({}, createButtonVariant(button.tertiary, tokens)))), ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.color) === "destructive" &&
                    (ownerState === null || ownerState === void 0 ? void 0 : ownerState.variant) === "text" && Object.assign({}, createButtonVariant(button.destructive.tertiary, tokens)))), { "&.Mui-disabled .MuiLoadingButton-loadingIndicator": {
                        color: loadingIndicator.indicator.backgroundColor.value,
                    }, "&.Mui-disabled .MuiLoadingButton-loadingIndicator + svg": Object.assign({ opacity: 0, fontSize: button.icon.height.value }, getIconOffsets(ownerState === null || ownerState === void 0 ? void 0 : ownerState.size, tokens)), "& .MuiButton-startIcon, & .MuiButton-endIcon": {
                        height: button.icon.height.value,
                        width: button.icon.width.value,
                        "& svg": {
                            fontSize: button.icon.height.value,
                        },
                    }, "& .MuiButton-startIcon, & .MuiLoadingButton-startIconLoadingStart": {
                        marginLeft: `-${semantic.spacing.sm.value}`,
                        marginRight: 0,
                    }, "& .MuiButton-endIcon, & .MuiLoadingButton-startIconLoadingEnd": {
                        marginLeft: 0,
                        marginRight: `-${semantic.spacing.sm.value}`,
                    }, "& > svg:only-child": Object.assign({ height: button.icon.height.value, width: button.icon.width.value, fontSize: button.icon.height.value }, getIconOffsets(ownerState === null || ownerState === void 0 ? void 0 : ownerState.size, tokens)), "& .MuiCircularProgress-circle": {
                        strokeWidth: 6.4,
                    }, 
                    // This styling properties will be moved to a global class to achieve consistency between an independent loading indicator and the one that is used inside a button
                    "& .MuiLoadingButton-loadingIndicator::before": {
                        display: "block",
                        content: '""',
                        width: loadingIndicator.circular.sm.width.value,
                        height: loadingIndicator.circular.sm.height.value,
                        borderRadius: "50%",
                        position: "absolute",
                        boxShadow: `inset 0px 0px 0 3.5px ${loadingIndicator.track.backgroundColor.value}`,
                    }, "&:has(.MuiLoadingButton-loadingIndicatorStart)": {
                        display: "flex",
                        paddingLeft: semantic.spacing.md.value,
                        "&.Mui-disabled .MuiButton-startIcon": {
                            display: "none",
                        },
                        ".MuiLoadingButton-loadingIndicator": {
                            position: "unset",
                        },
                    }, "&:has(.MuiLoadingButton-loadingIndicatorEnd)": {
                        display: "flex",
                        paddingRight: semantic.spacing.md.value,
                        "&.Mui-disabled .MuiButton-endIcon": {
                            display: "none",
                        },
                        ".MuiLoadingButton-loadingIndicator": {
                            position: "unset",
                        },
                    } })),
            },
        },
        MuiIconButton: {
            defaultProps: {
                size: "medium",
            },
            styleOverrides: {
                root: ({ ownerState }) => (Object.assign(Object.assign(Object.assign(Object.assign({ borderRadius: button.borderRadius.value, color: button.tertiary.default.color.value }, ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.size) === "large" && {
                    width: button.iconOnly.large.width.value,
                    height: button.iconOnly.large.width.value,
                })), ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.size) === "small" && {
                    padding: 0,
                    width: button.small.height.value,
                    height: button.small.height.value,
                    "& svg": {
                        lineHeight: 1,
                        fontSize: semantic.iconSize.sm.value,
                    },
                })), ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.size) === "medium" && {
                    padding: `0 ${button.iconOnly.paddingHorizontal.value}`,
                    width: button.iconOnly.width.value,
                    height: button.iconOnly.width.value,
                    "& svg": {
                        width: button.icon.width.value,
                        height: button.icon.height.value,
                        lineHeight: button.icon.height.value,
                        fontSize: button.icon.height.value,
                    },
                })), { "&:hover": {
                        backgroundColor: button.tertiary.hover.backgroundColor.value,
                        color: button.tertiary.hover.color.value,
                    }, "&:active": {
                        backgroundColor: button.tertiary.active.backgroundColor.value,
                        color: button.tertiary.active.color.value,
                    }, "&.MuiDisabled": {
                        backgroundColor: button.tertiary.disabled.backgroundColor.value,
                        color: button.tertiary.disabled.color.value,
                    }, "&:focus": {
                        boxShadow: button.focus.boxShadow.value.stringValue,
                    } })),
            },
        },
    };
};
export default button;
//# sourceMappingURL=button.js.map